
import { useState } from 'react';

interface GroupRulesWidgetProps {
  rules: string[];
  isOwnerOrAdmin: boolean;
  onOpenSettings: () => void;
}

const GroupRulesWidget = ({ rules, isOwnerOrAdmin, onOpenSettings }: GroupRulesWidgetProps) => {
  const [expanded, setExpanded] = useState(false);
  const displayRules = expanded ? rules : rules.slice(0, 4);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-shield-check-line text-teal-500"></i>
          </div>
          <h3 className="font-semibold text-gray-900">Group Rules</h3>
        </div>
        {isOwnerOrAdmin && (
          <button
            onClick={onOpenSettings}
            className="text-xs text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-edit-line text-sm"></i>
            Edit
          </button>
        )}
      </div>

      <div className="p-4">
        {rules.length === 0 ? (
          <div className="text-center py-4">
            <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-2">
              <i className="ri-file-list-3-line text-lg text-gray-400"></i>
            </div>
            <p className="text-sm text-gray-500 mb-1">No rules set yet</p>
            {isOwnerOrAdmin && (
              <button
                onClick={onOpenSettings}
                className="text-xs text-teal-600 hover:text-teal-700 font-medium cursor-pointer whitespace-nowrap"
              >
                + Add group rules
              </button>
            )}
          </div>
        ) : (
          <div className="space-y-2.5">
            {displayRules.map((rule, index) => (
              <div key={index} className="flex items-start gap-2.5">
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  {index + 1}
                </span>
                <p className="text-sm text-gray-700 leading-relaxed flex-1">{rule}</p>
              </div>
            ))}

            {rules.length > 4 && (
              <button
                onClick={() => setExpanded(!expanded)}
                className="w-full text-center text-xs text-teal-600 hover:text-teal-700 font-medium pt-2 cursor-pointer flex items-center justify-center gap-1"
              >
                {expanded ? (
                  <>
                    <i className="ri-arrow-up-s-line"></i>
                    Show Less
                  </>
                ) : (
                  <>
                    <i className="ri-arrow-down-s-line"></i>
                    Show All {rules.length} Rules
                  </>
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupRulesWidget;
